(function() {
  'use strict';

  var STATE_ORDER = [
    'draft',
    'published',
    'archived'
  ];

  function Search($translate, Roles, VERSION_STATES) {
    function getRoles() {
      return Roles.findAll({ includeSystemRoles: true })
        .then(function(data) {
          var roles = _.sortBy(data.map(function(obj) {
            return { id: obj.doc._id, key: obj.doc._id, title: obj.doc.title };
          }), 'name');
          roles.unshift(
            {
              id: '__all__',
              key: '__all__',
              title: $translate.instant('Only those with \'All roles\' option')
            }
          );
          return roles;
        });
    }

    var roles = getRoles();

    var getSearch = function() {
      var search = {
        facetly: {
          facets: [
            {
              id: 'text',
              type: 'search',
              label: $translate.instant('Start typing to search')
            },
            {
              id: 'groupState',
              type: 'select',
              label: $translate.instant('State'),
              multiselect: true,
              options: [
                { id: VERSION_STATES.draft, title: $translate.instant('Draft') },
                { id: VERSION_STATES.published, title: $translate.instant('Published') },
                { id: VERSION_STATES.archived, title: $translate.instant('Archived') }
              ],
              facetly: false,
              advanced: true
            },
            {
              id: 'roles',
              type: 'select',
              label: $translate.instant('Can be run by'),
              multiselect: true,
              options: roles,
              facetly: false,
              advanced: true
            }
          ],
          options: {
            defaultFacet: 'text',
            placeholder: $translate.instant('Start typing to search...'),
            listMaxItems: 10
          }
        },
        filters: [
          {
            id: 'name',
            matchFunc: function(doc, _key, value) {
              if (!value) { return true; }

              var val = value.toLowerCase(),
                  name = doc.doc.title.toLowerCase();
              return name.indexOf(val) > -1;
            }
          },
          {
            id: 'state'
          }
        ],
        orders: {
          name: function(item) {
            return item.doc.title.toLowerCase();
          },
          state: function(item) {
            return STATE_ORDER.indexOf(item.doc.state);
          }
        },
        orderGroups: {
          state: {
            title: $translate.instant('state'),
            orders: ['state', 'name']
          },
          name: {
            title: $translate.instant('name'),
            orders: ['name']
          },
          added: {
            title: $translate.instant('added'),
            orders: ['added', 'name']
          },
          modified: {
            title: $translate.instant('most recent'),
            orders: ['modified', 'name']
          }
        },
        defaultFilter: {
        },
        defaultOrder: 'state'
      };
      return search;
    };

    var service = {
      search: getSearch()
    };

    return service;
  }

  Search.$inject = ['$translate', 'RolesService', 'VERSION_STATES'];

  angular.module('component.reports')
    .service('ReportTemplateSearch', Search);
})();
